import { render, staticRenderFns } from "./ristorante.vue?vue&type=template&id=07e374a2&"
import script from "./ristorante.vue?vue&type=script&lang=js&"
export * from "./ristorante.vue?vue&type=script&lang=js&"
import style0 from "./ristorante.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports